import EsNavBar from './EsNavBar';
import EsRibbon, { useEsRibbonMessage } from './EsRibbon';
import EsFooter from "./EsFooter";
import {Outlet} from "react-router-dom";
import EsScrollToTop from "../util/EsScrollToTop";
import EsPageTitle from "./EsPageTitle";
import EsAnalytics from "../../common/EsAnalytics";
import EsRumRoute from "../../common/EsRumRoute";
import EsLastGame from "../game/EsLastGame";
import EsSessionExpiry from "./EsSessionExpiry";
import EsAccountDeletedNote from "../account/EsAccountDeletedNote";
import { EsGuardianBanNotice } from "../../common/EsGuardian";

export default function EsParent() {
  // Whether to leave room at the top, from the same rule that decides whether
  // there is anything to leave room for. See useEsRibbonMessage.
  const aRibbon = useEsRibbonMessage();

  return (
      /* The page's ground and the ink every view below inherits.
         Two tokens where there were four classes -- a white ground and black ink
         with a blue-900 ground and white ink beside them under the dark variant.
         --color-surface and --color-on-surface are declared once in EsCommon.css
         and re-pointed there for dark; see the long note in that file for why a
         variable rather than a pair. Nothing here can now state the light half
         and forget the dark one, which is how light mode broke in four separate
         places the round before this. */
      <div data-testid="es-app-shell"
           className={ "flex min-h-dvh flex-col print:block print:min-h-0 bg-surface text-on-surface" + ( aRibbon ? " esRibbonOffset" : "" ) }>
          <EsScrollToTop />
          { /* Effect-only, like EsScrollToTop above it: sets the tab title from
               the session. Here rather than in each view so there is one answer
               to what the tab says, and inside the shell so it is under the
               AuthProvider that index.js mounts. */ }
          <EsPageTitle />
          { /* Effect-only: one GA4 page view per route change, and nothing at
               all unless the build was given a measurement ID (prod's). */ }
          <EsAnalytics />
          { /* Effect-only: names the route for New Relic, and nothing at all
               unless the build was given a New Relic app (dev's and prod's). */ }
          <EsRumRoute />
          { /* Effect-only: a sign-in lands on the last game while its session runs. */ }
          <EsLastGame />
          { /* Effect-only: a session that runs out sends the reader to the login. */ }
          <EsSessionExpiry />
          { /* Above the nav bar in the source because it is above it on the
               screen, though it is `fixed` and would render there wherever it
               sat -- EsNavBar is `absolute top-0`, so a ribbon in the flow
               would be hidden underneath it. EsRibbon.js has the reasoning and
               the one cost it accepts. Renders nothing at all unless
               switchEsRibbon carries text, which is almost never. */ }
          <EsRibbon />
          <EsNavBar />
          <EsAccountDeletedNote />
          <EsGuardianBanNotice />
          { /* The one thing in the shell's flex column that grows, so the
               footer meets the viewport's bottom edge on a short page. A
               wrapper rather than `grow` on each view: the Outlet renders
               whichever route it is, and RequireAuth renders nothing at all
               while it waits. A plain block, not a flex container, so the
               views keep their own flow. The two print: variants above hand
               the printer the shell it had -- a paged sheet inside a flex
               column at least a viewport tall is two things the print
               stylesheets were never written against. */ }
          <div className="grow">
              <Outlet />
          </div>
          <EsFooter />
      </div>
  );
}

